import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { TemplateListProps } from './TemplateList'

const TemplateListLazy = lazy(() => import('./TemplateList'))

const TemplateList: FC<TemplateListProps> = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <TemplateListLazy {...props} />
    </Suspense>
  )
}

export default TemplateList
